var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavConfigurationOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.6 17.2",
    style: {
      enableBackground: "new 0 0 17.6 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.7,
    y1: 7.8,
    x2: 2.7,
    y2: 16.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.7,
    y1: 0.7,
    x2: 2.7,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.9,
    y1: 7.8,
    x2: 14.9,
    y2: 16.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.9,
    y1: 0.7,
    x2: 14.9,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.8,
    y1: 13.2,
    x2: 8.8,
    y2: 16.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.8,
    y1: 0.7,
    x2: 8.8,
    y2: 9.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 2.7,
    cy: 5.9,
    rx: 1.9,
    ry: 1.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 14.9,
    cy: 5.9,
    rx: 1.9,
    ry: 1.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8.8,
    cy: 11.3,
    rx: 1.9,
    ry: 1.9
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavConfigurationOn);
export default __webpack_public_path__ + "static/media/nav_configuration_on.63a627c888ea61b37530ce5e5bfc1185.svg";
export { ForwardRef as ReactComponent };